export const firstLetterCapitalized = (str: string): string => {
    const result = str.charAt(0).toUpperCase() + str.slice(1);
    return result;
  };


